import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Spinner.scss';

export const Spinner = ({ dark }) => {
  const classes = cn({
    [styles.spinner]: true,
    [styles.dark]: dark,
    [styles.light]: !dark
  });

  return (
    <svg className={classes} height="16px" viewBox="0 0 66 66" width="16px" xmlns="http://www.w3.org/2000/svg">
      <circle className={styles.path} cx="33" cy="33" fill="none" r="30" strokeLinecap="round" strokeWidth="4" />
    </svg>
  );
};

Spinner.propTypes = {
  dark: PropTypes.bool
};

Spinner.defaultProps = {
  dark: false
};

export default Spinner;
